import { render, staticRenderFns } from "./EmailView.vue?vue&type=template&id=69ea6b4f&scoped=true&"
import script from "./EmailView.vue?vue&type=script&lang=js&"
export * from "./EmailView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ea6b4f",
  null
  
)

export default component.exports